virtual function void build_phase(uvm_phase phase);
{{#unless isFirstLevelComponent}}
  super.build_phase(phase);
{{/unless}}
  {{> (partial "snippets/check-instance-variables-set")}}
endfunction
